import { motion } from 'framer-motion';
import React from 'react';

interface ResultCardProps {
  icon: React.ReactNode;
  title: string;
  value: string | React.ReactNode;
  subtitle?: string;
  color?: string;
  className?: string;
}

const ResultCard: React.FC<ResultCardProps> = ({
  icon,
  title,
  value,
  subtitle,
  color = '#3B82F6',
  className = '',
}) => {
  return (
    <motion.div
      className={`bg-white rounded-2xl p-6 shadow-lg border border-gray-100 ${className}`}
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.2 }}
    >
      <div className="flex items-center mb-3">
        <div
          className="p-2 rounded-lg mr-3"
          style={{ backgroundColor: `${color}20` }}
        >
          <div style={{ color }}>{icon}</div>
        </div>
        <h3 className="text-lg font-semibold text-gray-600">{title}</h3>
      </div>
      <div className="text-2xl font-bold mb-1" style={{ color }}>
        {value}
      </div>
      {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
    </motion.div>
  );
};

export default ResultCard;
